import Immutable from 'immutable'
import {
   WINDOW_RESIZE,
} from '../constants/util-constants'

const initialState = Immutable.fromJS({
   windowHeight: null,
   windowWidth: null,
   appHeight: null,
   appWidth: null,
})
export default (state = initialState, action) => {
  switch (action.type) {
    case WINDOW_RESIZE:
      // set the window width and height, but with reasonable minimums
      return (state.withMutations(s => {
        // Standard HD Monitor: 1920x1080
        // Standard Laptop:     1280x800
        // Ideum 2x:            2160x3840 (portrait) (2x 2160x1920)
        let height = action.payload.windowHeight || 800
        let width = action.payload.windowWidth || 1280
        height = Math.max(height, 900)  // min height
        height = Math.min(height, 1920) // max height
        width = Math.max(width, 1280)   // min width
        width = Math.min(width, 2160)   // max width
        s.set('appHeight', height).set('appWidth', width)
         .set('windowHeight', action.payload.windowHeight)
         .set('windowWidth', action.payload.windowWidth)
     }))
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/util-reducers.js